import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import {useNavigate} from "react-router-dom";

const AboutS2 = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentWrapTitle}`}>{t('Больше')}</div>
                    <div className={`${Styles.contentWrapSubTitle}`}>{t('чем лаунчпад')}</div>
                    <div className={`${Styles.noteWrap}`}>
                        <div className={`${Styles.note}`}>{t('Мы создаём инфраструктуру запуска, где проекты получают реальные шансы на рост и развитие, а не на мгновенный успех. Участники получают прямой доступ к тщательно отобранным возможностям, а стартапы — к активному, обученному и вовлечённому сообществу.')}</div>
                        <div className={`${Styles.note}`}>{t('Наш подход сочетает инновационные технологии, безопасные процессы и выгодные условия, формируя пространство, в котором все стороны достигают реальной ценности и стабильного результата.')}</div>
                    </div>
                    <div className={`${Styles.aboutBtn}`} onClick={() => navigate('/sign-up')}>{t('Начать работу')}</div>
                </div>
            </div>
        </section>
    );
};

export default AboutS2;




